export const environment = {
  appVersion: require('../../package.json').version + '-dev',
  production: false,
  API_url: 'http://api.dev.antecipagov.com.br/',
  broad_website: 'http://site.dev.broadfactor.com/',
  antecipa_website: 'http://dev.antecipagov.com.br/',
};
